export enum FundingSourceType {
  CREDIT_DEBIT = "CREDIT_DEBIT",
  CHEQUE = "CHEQUE",
}
